import { render, staticRenderFns } from "./ConnectWallet.vue?vue&type=template&id=3e23785d&scoped=true&"
import script from "./ConnectWallet.vue?vue&type=script&lang=js&"
export * from "./ConnectWallet.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWallet.vue?vue&type=style&index=0&id=3e23785d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e23785d",
  null
  
)

export default component.exports